export const translation = {
  projectName: 'SPD',

  header: {
    navigation: {
      default: [],
      admin: [
        {
          name: 'Projekte',
          link: '/dashboard/files',
        },
      ],
      isLoggedIn: {
        name: 'Abmelden',
      },
    },
  },

  cube: {
    rotate: 'Dreh mit dem Finger den Cube',
    rotateDesktop: 'Dreh mit der Maus den Cube',
  },

  cubePopup: {
    countdownPrefix: 'PROGRAMM-CUBE START IN',
    newsalarmLinkLabel: 'Jetzt eintragen und nichts verpassen',
    pressLinkLabel: 'Jetzt Pressematerial herunterladen',
    days: 'Tagen',
    hours: 'Stunden',
    minutes: 'Minuten',
  },

  backToCube: {
    cta: 'Zurück zum Cube',
  },

  leadform: {
    // headline: 'JETZT ANMELDEN UND ZUERST ÜBER ALLE PROGRAMM-CUBE UPDATES INFORMIERT WERDEN.',
    headline: 'Jetzt anmelden und keine Neuigkeiten mehr verpassen!',
  },

  programPage: {
    headline: 'NUR EIN STARKES PROGRAMM FÜR DICH IST AUCH EIN STARKES SPD-PROGRAMM.',
    download: 'Entwurf Regierungsprogramm [PDF | 764 KB]',
  },

  login: {
    headline: 'Anmelden',
    cta: 'Anmelden',
    error: 'Anmeldung fehlgeschlagen. Falsche E-Mail oder Passwort.',
  },

  trackingHint: {
    preRecall:
      'Wir verwenden Cookies, die zur Nutzung der Webseite notwendig sind. Daneben nehmen wir in unserem Interesse zur Feststellung der Reichweite unserer Inhalte mithilfe des Webanalysedienstes Matomo eine Reichweitenanalyse vor, wobei wir gekürzte IP-Adressen verwenden, die eine Personenbeziehbarkeit ausschließen. Dem kannst Du ',
    recallLabel: 'hier widersprechen',
    recallHref: 'https://www.spd.de/site/datenschutz/#c38250',
    preDataProtection: '. Weitere Informationen findest Du ',
    dataProtectionLabel: 'in unseren Datenschutzhinweisen',
    dataProtectionHref: 'https://www.spd.de/site/datenschutz/',
    suffix: '.',
  },

  footer: {
    links: 'Links',
    legalLinks: [
      { name: 'Impressum', link: 'https://www.spd.de/site/impressum' },
      { name: 'Datenschutz', link: 'https://www.spd.de/site/datenschutz' },
      { name: 'AGB', link: 'https://www.spd.de/site/agb' },
      { name: 'Kontakt', link: 'https://www.spd.de/site/kontakt' },
    ],
  },

  generic: {
    company: {
      name: 'SPD - 2025',
    },
    settings: 'Einstellungen',
    hourPrefix: 'Stunden: ',
    hourSuffix: ' Stunden',
    squareMeterSuffix: ' m²',
    equals: ' = ',
    timestampPrefix: 'Erstellt am: ',
    phonePrefix: 'Telefon: ',
    mailPrefix: 'E-Mail: ',
    websitePrefix: 'Webseite: ',
    employeeSuffix: ' Mitarbeiter',
    salutation: 'Anrede',
    name: 'Name',
    firstname: 'Vorname',
    lastname: 'Nachname',
    birthday: 'Geburtsdatum',
    personType: 'Art',
    personTypePlaceholder: 'Beirat, Geschäftsführer, ...',
    street: 'Straße, Hausnummer',
    companyName: 'Firmenname',
    club: 'Verein (optional)',
    city: 'PLZ, Ort',
    mail: 'E-Mail-Adresse',
    identifier: 'E-Mail-Adresse',
    message: 'Ihre Anfrage...',
    phone: 'Telefonnummer',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    createdOn: 'Erstellt am',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    close: 'Schließen',
    send: 'Senden',
    error: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.',
    acceptAGB: 'Ich akzeptiere die AGB',
    percent: ' %',
    kilometerSuffix: ' km',
    upload: 'Hochladen',
    login: 'Anmelden',
    logout: 'Abmelden',
    export: 'Export',
    import: 'Import',
    save: 'Speichern',
  },

  UI: {
    removeConfirmation: {
      title: 'Bestätigung',
      text: (itemName: string) => `Möchten Sie "${itemName}" wirklich löschen?`,
    },
    copyConfirmation: {
      title: 'Kopieren',
      text: (itemName: string) => `${itemName}-Kopie umbenennen zu:`,
      initNameSuffix: '-Kopie',
    },
    customerSelector: {
      label: 'Kundenauswahl',
    },
    projectSelector: {
      label: 'Projekt wählen',
    },
    simpleList: {
      search: 'Suche',
      resultAmountSuffixPlural: ' Ergebnisse',
      resultAmountSuffixSingular: ' Ergebnis',
      noData: 'Keine Daten vorhanden',
    },
    multiList: {
      search: 'Suche',
      resultAmountSuffix: ' Ergebnisse',
      noData: 'Keine Daten vorhanden',
      cta: 'Ausführen',
      cancelCTA: 'Abbrechen',
      option: {
        EXPORT: 'Export',
        PROCESS: 'Verarbeiten',
        STOP: 'Stoppen',
      },
      export: {
        title: 'Export',
        identifier: 'Kennung',
      },
      error: 'Aktion konnte nicht ausgeführt werden',
    },
    csvImport: {
      title: 'Import',
      startCTA: 'Import starten',
      loading: 'Daten werden imporiert...',
      error: 'Der Import ist fehlgeschlagen.',
    },
    dropdown: {
      emptySelection: 'Bitte wählen',
      search: 'Suche',
    },
    selectableTagList: {
      showMore: 'Mehr anzeigen',
      showLess: 'Weniger',
    },
    textarea: {
      max: {
        prefix: 'maximal ',
        suffix: ' Zeichen',
      },
    },
    dnd: {
      text: 'Bewerbung anhängen',
      hint: '(Erlaubt ist eine PDF-Datei bis zu 25 MB)',
      selectedPrefix: 'Gewählte PDF: ',
      error: {
        size: 'Maximale Dateigröße überschritten',
      },
    },
  },

  resetPassword: {
    passwordsDontMatch: 'Passwörter stimmen nicht überein',
    passwordReset: 'Passwort wurde erfolgreich geändert',
    save: 'Ändern',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    title: 'Passwort ändern',
  },
}

export const langKey = 'DE'
